const correlationMatrixCopy = {
  warningMessage: 'There is no correlation data at this time.'
};

export default correlationMatrixCopy;
